import { useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/popover";

const TODAY = new Date();

const toDate = (str) => {
  if (!str) return undefined;
  const d = new Date(`${str}T00:00:00`);
  return isNaN(d) ? undefined : d;
};

export const BirthDatePicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const selected = toDate(value);

  const handleSelect = (d) => {
    if (!d) return;
    onChange(format(d, "yyyy-MM-dd"));
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex w-full items-center justify-between rounded-xl bg-[#1B1C1F] border border-[#2A2C30] px-4 py-3 text-sm text-left text-[#F2F0EB] hover:border-[#F2F0EB]/40 focus:outline-none focus:border-[#F2F0EB]/40 transition-colors"
          data-testid="secure-date-input"
        >
          <span className={selected ? "text-[#F2F0EB]" : "text-[#737687]"}>
            {selected ? format(selected, "d MMMM yyyy") : "Select your birth date"}
          </span>
          <CalendarIcon size={16} className="text-[#737687] shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-auto p-3 bg-[#141416] border-[#2A2C30] text-[#F2F0EB]"
        data-testid="secure-date-popover"
      >
        <div className="birthdate-rdp">
          <DayPicker
            mode="single"
            selected={selected}
            onSelect={handleSelect}
            captionLayout="dropdown-buttons"
            fromYear={1920}
            toYear={TODAY.getFullYear()}
            defaultMonth={selected || new Date(1995, 5)}
            disabled={{ after: TODAY }}
            showOutsideDays
          />
        </div>
      </PopoverContent>
    </Popover>
  );
};
